const SalesforceUsersImport = () => import('@/views/account/integrations/salesforce/import/salesforce-users-import-view.vue');
const SalesforceCompaniesImport = () => import('@/views/account/integrations/salesforce/import/salesforce-companies-import-view.vue');
const SalesforceContactsImport = () => import('@/views/account/integrations/salesforce/import/salesforce-contacts-import-view');
const SalesforceActivitiesImport = () => import('@/views/account/integrations/salesforce/import/salesforce-activities-import-view');
const SalesforceOpportunitiesImport = () => import('@/views/account/integrations/salesforce/import/salesforce-opportunities-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Salesforce/Manage/Users/Import',
        name: 'SalesforceUsersImport',
        component: SalesforceUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Users/Import',
        name: 'ClientSalesforceUsersImport',
        component: SalesforceUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Companies/Import',
        name: 'SalesforceCompaniesImport',
        component: SalesforceCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Companies/Import',
        name: 'ClientSalesforceCompaniesImport',
        component: SalesforceCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Contacts/Import',
        name: 'SalesforceContactsImport',
        component: SalesforceContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Contacts/Import',
        name: 'ClientSalesforceContactsImport',
        component: SalesforceContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Activities/Import',
        name: 'SalesforceActivitiesImport',
        component: SalesforceActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Activities/Import',
        name: 'ClientSalesforceActivitiesImport',
        component: SalesforceActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Salesforce/Manage/Opportunities/Import',
        name: 'SalesforceOpportunitiesImport',
        component: SalesforceOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Salesforce/Manage/Opportunities/Import',
        name: 'ClientSalesforceOpportunitiesImport',
        component: SalesforceOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]